import moment from "moment";

const formatSecondsToDuration = (seconds) => {
  const duration = moment.duration(seconds, "seconds");
  return moment.utc(duration.asMilliseconds()).format("HH:mm:ss");
};

export default formatSecondsToDuration;
